import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { MatAutocompleteModule, } from '@angular/material/autocomplete';
import { MatFormFieldModule, MatInputModule } from '@angular/material';
import { ModalModule } from 'ngx-bootstrap';
import { DxButtonModule } from "devextreme-angular";
import { DxChartModule } from "devextreme-angular";
import {MatExpansionModule} from '@angular/material/expansion';


import { NgxPaginationModule } from 'ngx-pagination'; 
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AuthService } from './core/auth/auth.service';
import { AuthGuardService } from './core/auth/auth-guard.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginPageComponent } from './modules/login-page/login-page.component';
import { HomeComponent } from './modules/home/home.component';
import { RegisterComponent } from './modules/register/register.component';
import { FilterPipe } from './filter.pipe';
import { LoginMultiRoleComponent } from './modules/login-page/login-multi-role/login-multi-role.component';
// import { AddVstsComponent } from './modules/user/add-project/add-vsts/add-vsts.component';
import { UserService } from './core/user.service';
// import { ConfigurationVstsComponent } from './modules/configuration-module/configuration-vsts/configuration-vsts.component';
import { AuthGuard } from './auth.guard';
import { TokenInterceptorService} from './core/token-interceptor.service';
import { FilterComponent } from './filter/filter.component';
import { ScanPipe } from './filter/scan.pipe';

import { AlertComponent } from './_directives/index';
import { AlertService } from './_services/index';

import { ToastrModule } from 'ngx-toastr';
import { AnalyticsModalComponent } from './_models/analytics-modal/analytics-modal.component';
import {MatDialogModule} from "@angular/material";
import { PerformanceModalComponent } from './_models/performance-modal/performance-modal.component';
import { LogUploadModalComponent } from './_models/log-upload-modal/log-upload-modal.component';
import { LoganalyticsDeviceComponent } from './_models/loganalytics-device/loganalytics-device.component';
import { LineTrendComponent } from './line-trend/line-trend.component';
import { ValidatePanelComponent } from './validate-panel/validate-panel.component';
import { TableComponent } from './table/table.component';
import { IssueComponent } from './issue/issue.component';
import { HeaderComponent } from './header/header.component';
import { CardsComponent } from './cards/cards.component';
import { ApproveClassificationComponent } from './approve-classification/approve-classification.component';
import { DashboardhComponent } from './dashboardh/dashboardh.component';
import { CqmNsComponent } from './modules/cqm-ns/cqm-ns.component';
import { CqmNsAnalyticsComponent } from './modules/cqm-ns/cqm-ns-analytics/cqm-ns-analytics.component';
import { CqmNsMonitoringComponent } from './modules/cqm-ns/cqm-ns-monitoring/cqm-ns-monitoring.component';
import { CqmNsActionsComponent } from './modules/cqm-ns/cqm-ns-actions/cqm-ns-actions.component';
import { CqmNsReportsComponent } from './modules/cqm-ns/cqm-ns-reports/cqm-ns-reports.component';
import { CqmNsDefectComponent } from './modules/cqm-ns/cqm-ns-defect/cqm-ns-defect.component';
import { CqmnsProjectCardsComponent } from './modules/cqm-ns/cqm-ns-defect/cqmns-project-cards/cqmns-project-cards.component';
import { CqmnsAppRatingComponent } from './modules/cqm-ns/cqm-ns-defect/cqmns-app-rating/cqmns-app-rating.component';
import { CqmnsClassificationSummaryComponent } from './modules/cqm-ns/cqm-ns-defect/cqmns-classification-summary/cqmns-classification-summary.component';
import { CqmnsClassificationTrendComponent } from './modules/cqm-ns/cqm-ns-defect/cqmns-classification-trend/cqmns-classification-trend.component';
import { CqmnsRcaTrendComponent } from './modules/cqm-ns/cqm-ns-defect/cqmns-rca-trend/cqmns-rca-trend.component';
import { CqmnsAssigntoComponent } from './modules/cqm-ns/cqm-ns-defect/cqmns-assignto/cqmns-assignto.component';
import { CqmnsSentimetAnalysisComponent } from './modules/cqm-ns/cqm-ns-defect/cqmns-sentimet-analysis/cqmns-sentimet-analysis.component';
import { CqmnsFailedFunctionalityComponent } from './modules/cqm-ns/cqm-ns-defect/cqmns-failed-functionality/cqmns-failed-functionality.component';
import { CqmNsNavbarComponent } from './modules/cqm-ns/cqm-ns-navbar/cqm-ns-navbar.component';
import { CqmNsFooterComponent } from './modules/cqm-ns/cqm-ns-footer/cqm-ns-footer.component';
import { CqmnsProjectPopupComponent } from './_models/cqmns-project-popup/cqmns-project-popup.component';
import { CqmnsScanDefectComponent } from './modules/cqm-ns/cqm-ns-actions/cqmns-scan-defect/cqmns-scan-defect.component';
import { CqmnsValidateDefectComponent } from './modules/cqm-ns/cqm-ns-actions/cqmns-validate-defect/cqmns-validate-defect.component';
import { CqmnsApprovedDefectComponent } from './modules/cqm-ns/cqm-ns-actions/cqmns-approved-defect/cqmns-approved-defect.component';
import { CqmnsRecommendRcaComponent } from './modules/cqm-ns/cqm-ns-actions/cqmns-recommend-rca/cqmns-recommend-rca.component';
import { CqmnsSelectedRcaComponent } from './modules/cqm-ns/cqm-ns-actions/cqmns-selected-rca/cqmns-selected-rca.component';
import { CqmnsApprovedRcaComponent } from './modules/cqm-ns/cqm-ns-actions/cqmns-approved-rca/cqmns-approved-rca.component';
import { CqmnsUploadExcelDefectComponent } from './modules/cqm-ns/cqm-ns-actions/cqmns-upload-excel-defect/cqmns-upload-excel-defect.component';
import { CqmnsTotalVsClassifiedReportComponent } from './modules/cqm-ns/cqm-ns-reports/cqmns-total-vs-classified-report/cqmns-total-vs-classified-report.component';
import { CqmnsRcaFrequencyReportComponent } from './modules/cqm-ns/cqm-ns-reports/cqmns-rca-frequency-report/cqmns-rca-frequency-report.component';
import { CqmnsRcaTrendReportComponent } from './modules/cqm-ns/cqm-ns-reports/cqmns-rca-trend-report/cqmns-rca-trend-report.component';
import { CqmnsClassificationTrendReportComponent } from './modules/cqm-ns/cqm-ns-reports/cqmns-classification-trend-report/cqmns-classification-trend-report.component';
import { CqmnsGaUsersummaryComponent } from './modules/cqm-ns/cqm-ns-analytics/cqmns-ga-usersummary/cqmns-ga-usersummary.component';
import { CqmnsGaDevicesummaryComponent } from './modules/cqm-ns/cqm-ns-analytics/cqmns-ga-devicesummary/cqmns-ga-devicesummary.component';
import { CqmnsGaPageviewsComponent } from './modules/cqm-ns/cqm-ns-analytics/cqmns-ga-pageviews/cqmns-ga-pageviews.component';
import { CqmnsCpuUtilizationComponent } from './modules/cqm-ns/cqm-ns-monitoring/cqmns-cpu-utilization/cqmns-cpu-utilization.component';
import { CqmnsMemoryUtilizationComponent } from './modules/cqm-ns/cqm-ns-monitoring/cqmns-memory-utilization/cqmns-memory-utilization.component';
import { CqmnsJavaheapUtilizationComponent } from './modules/cqm-ns/cqm-ns-monitoring/cqmns-javaheap-utilization/cqmns-javaheap-utilization.component';
import { CqmnsServerStatusComponent } from './modules/cqm-ns/cqm-ns-monitoring/cqmns-server-status/cqmns-server-status.component';
import { CqmnsLogAnalyticsComponent } from './modules/cqm-ns/cqmns-log-analytics/cqmns-log-analytics.component';
import { CqmnsLogDevicesummaryComponent } from './modules/cqm-ns/cqmns-log-analytics/cqmns-log-devicesummary/cqmns-log-devicesummary.component';
import { CqmnsLogPageviewsComponent } from './modules/cqm-ns/cqmns-log-analytics/cqmns-log-pageviews/cqmns-log-pageviews.component';
import { CqmnsLogUsersummaryComponent } from './modules/cqm-ns/cqmns-log-analytics/cqmns-log-usersummary/cqmns-log-usersummary.component';
import { AuthSecComponent } from './modules/cqm-ns/auth-sec/auth-sec.component';
import { CqmNsAnalyseDefectsComponent } from './modules/cqm-ns/cqm-ns-actions/cqm-ns-analyse-defects/cqm-ns-analyse-defects.component';
import { CqmNsDefectsDuplicationsComponent } from './modules/cqm-ns/cqm-ns-actions/cqm-ns-defects-duplications/cqm-ns-defects-duplications.component';


const appRoutes: Routes = [


    // {
    //     path: 'configure/vsts/:projectId',
    //     component: ConfigurationVstsComponent,
    //     canActivate: [AuthGuard]
    // },

    {
        path: 'login',
        component: LoginPageComponent,
      //  pathMatch: 'full'
    },
    {
        path: 'roleSelect/:user_id',
        component: LoginMultiRoleComponent
    },
    {
        path: 'register',
        component: RegisterComponent,
        pathMatch: 'full'
    },
  

    // {
    //     path: 'newProject/vsts/:projectId',
    //     component: AddVstsComponent,
    //     canActivate: [AuthGuard]
    // },
   

    {
        path: 'auth-sec',
        component: AuthSecComponent,
       // canActivate: [AuthGuardService]
    },
    {
        path: 'cqm-ns',
        component: CqmNsComponent,
       // canActivate: [AuthGuardService]
    },
    {
        path: 'cqmns-scan-defect',
        component: CqmnsScanDefectComponent,
        //  canActivate: [AuthGuardService]
    },
    {
        path: 'cqmns-validate-defect',
        component: CqmnsValidateDefectComponent,
        //  canActivate: [AuthGuardService]
    },
    {
        path: 'cqmns-approved-defect',
        component: CqmnsApprovedDefectComponent,
        //  canActivate: [AuthGuardService]
    },
    {
        path: 'cqmns-recommend-rca',
        component: CqmnsRecommendRcaComponent,
        //  canActivate: [AuthGuardService]
    },
    {
        path: 'cqmns-selected-rca',
        component: CqmnsSelectedRcaComponent,
        //  canActivate: [AuthGuardService]
    },
    {
        path: 'cqmns-approved-rca',
        component: CqmnsApprovedRcaComponent,
        //  canActivate: [AuthGuardService]
    },
    {
        path: 'cqmns-classification-trend-report',
        component: CqmnsClassificationTrendReportComponent,
        //  canActivate: [AuthGuardService]
    },
    {
        path: 'cqmns-rca-trend-report',
        component: CqmnsRcaTrendReportComponent,
        //  canActivate: [AuthGuardService]
    },
    {
        path: 'cqmns-rca-frequency-report',
        component: CqmnsRcaFrequencyReportComponent,
        //  canActivate: [AuthGuardService]
    },
    {
        path: 'cqmns-total-vs-classified-report',
        component: CqmnsTotalVsClassifiedReportComponent,
        //  canActivate: [AuthGuardService]
    },
    {
        path: 'cqmns-upload-excel-defect',
        component: CqmnsUploadExcelDefectComponent,
        //  canActivate: [AuthGuardService]
    },
    {
        path: 'cqm-ns-analyse-defects',
        component: CqmNsAnalyseDefectsComponent,
        //  canActivate: [AuthGuardService]
    },
    {
        path: 'cqm-ns-defects-duplications',
        component: CqmNsDefectsDuplicationsComponent,
        //  canActivate: [AuthGuardService]
    },
    {
        path: '**',
        redirectTo: '/auth-sec'
    }
];


@NgModule({
    declarations: [
        AppComponent,
        LineTrendComponent,
        ValidatePanelComponent,
        TableComponent ,
        IssueComponent ,
        HeaderComponent ,
        CardsComponent,
        ApproveClassificationComponent,
        DashboardhComponent,
    
        LoginPageComponent,
        HomeComponent,
        RegisterComponent,

        FilterPipe,      
        LoginMultiRoleComponent,
        // AddVstsComponent,
   
        // ConfigurationVstsComponent, 
        FilterComponent,
        ScanPipe,
        AlertComponent,

        AnalyticsModalComponent,
        PerformanceModalComponent,
        LogUploadModalComponent,
        LoganalyticsDeviceComponent,
        CqmNsComponent,
        CqmNsAnalyticsComponent,
        CqmNsMonitoringComponent,
        CqmNsActionsComponent,
        CqmNsReportsComponent,
        CqmNsDefectComponent,
        CqmnsProjectCardsComponent,
        CqmnsAppRatingComponent,
        CqmnsClassificationSummaryComponent,
        CqmnsClassificationTrendComponent,
        CqmnsRcaTrendComponent,
        CqmnsAssigntoComponent,
        CqmnsSentimetAnalysisComponent,
        CqmnsFailedFunctionalityComponent,
        CqmNsNavbarComponent,
        CqmNsFooterComponent,
        CqmnsProjectPopupComponent,
        CqmnsScanDefectComponent,
        CqmnsValidateDefectComponent,
        CqmnsApprovedDefectComponent,
        CqmnsRecommendRcaComponent,
        CqmnsSelectedRcaComponent,
        CqmnsApprovedRcaComponent,
        CqmnsUploadExcelDefectComponent,
        CqmnsTotalVsClassifiedReportComponent,
        CqmnsRcaFrequencyReportComponent,
        CqmnsRcaTrendReportComponent,
        CqmnsClassificationTrendReportComponent,
        CqmnsGaUsersummaryComponent,
        CqmnsGaDevicesummaryComponent,
        CqmnsGaPageviewsComponent,
        CqmnsCpuUtilizationComponent,
        CqmnsMemoryUtilizationComponent,
        CqmnsJavaheapUtilizationComponent,
        CqmnsServerStatusComponent,
        CqmnsLogAnalyticsComponent,
        CqmnsLogDevicesummaryComponent,
        CqmnsLogPageviewsComponent,
        CqmnsLogUsersummaryComponent,
        AuthSecComponent,
        CqmNsAnalyseDefectsComponent,
        CqmNsDefectsDuplicationsComponent,

    
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        MatAutocompleteModule,
        MatInputModule,
        BrowserAnimationsModule,
        MatFormFieldModule,
        DxButtonModule,
        DxChartModule,
        MatExpansionModule,
        BrowserAnimationsModule,
        MatDialogModule,
    	ToastrModule.forRoot( 
            { positionClass:"toast-bottom-right",  
            closeButton: true
     }),
        NgxPaginationModule, 
        RouterModule.forRoot(
            appRoutes,
            { enableTracing: true },
        ),
        ModalModule.forRoot()
    ],
    providers: [AuthService, AuthGuard, AuthGuardService, UserService,AlertService,
    {
        provide: HTTP_INTERCEPTORS,
        useClass:TokenInterceptorService,
        multi:true

    }],
    bootstrap: [AppComponent],
    entryComponents: [AnalyticsModalComponent,PerformanceModalComponent,LogUploadModalComponent,LoganalyticsDeviceComponent,CqmnsProjectPopupComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts